<template>
  <div id="app">
    <div class="gradient-overlay"></div>
    <mainContent />
    <agile class="carousel" :options="myOptions">
      <!-- Mettres les images dans le dossier public->pictures puis linker ici -->
      <img
        src="pictures/MSB_brigidabocini_sony.a7-9.jpg"
        alt=""
        class="slide"
      />
      <img
        src="pictures/red-eye_foto_couv.jpg"
        alt=""
        class="slide"
      />
      <img
        src="pictures/pluto_mod_ok.jpg"
        alt=""
        class="slide"
      />
      <img
        src="pictures/histoire_d_une_ligne.jpg"
        alt=""
        class="slide"
      />
    </agile>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile';

import mainContent from './components/mainContent.vue';

export default {
  name: 'App',
  components: {
    mainContent,
    agile: VueAgile,
  },
  data() {
    return {
      myOptions: {
        navButtons: true,
        dots: false,
        autoplay: true,
        fade: true,
        autoplaySpeed: 5000,
        speed: 1000,
        pauseOnHover: false,
        infinite: true,
      },
    };
  },
};
</script>

<style scoped>
#app {
  position: relative;
}

.carousel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
}

.slide {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  padding: 0;
  margin: 0;
}

/* Navigation buttons styling */
.carousel >>> .agile__nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.3);
  border: none;
  width: 50px;
  height: 50px;
  cursor: pointer;
  z-index: 100;
  font-size: 24px;
  color: #fff;
  border-radius: 50%;
}

.carousel >>> .agile__nav-button:hover {
  background: rgba(255, 255, 255, 0.5);
}

.carousel >>> .agile__nav-button--prev {
  left: 20px;
}

.carousel >>> .agile__nav-button--next {
  right: 20px;
}

.gradient-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 40%);
  z-index: 5;
  pointer-events: none;
}

</style>